import React, { useState } from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import { closeModal } from '../../../../../Features/lensSlice';
import { useDispatch, useSelector } from 'react-redux';
import ReportType from '../../ReportType';
import reportList from '../../reportList';
import { reportPost } from '../../../../../lib/utils/apiCalls';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function ReportPost() {
    const dispatch = useDispatch();

    const [reasons, setReasons] = useState([]);

    const selectedPost = useSelector((state) => state.lens.modal.selectedPost);

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleReportTypeClick = (type) => {
        const isPresent = Boolean(reasons.find(item => item.id === type.id));

        if(isPresent) {
            const filteredReasons = reasons.filter(item => item.id !== type.id);
            setReasons(filteredReasons);
        }
        else {
            setReasons([...reasons, type]);
        }
    }

    const handleSendReportButton = async () => {
        if(reasons.length > 0) {
            const reasonsList = reasons.map(item => item.name);

            try {
                const callData = {
                    reportedPostId: selectedPost.id,
                    reason: reasonsList
                }

                const response = await reportPost(callData);

                // eslint-disable-next-line eqeqeq
                if(response?.statusCode == 10000) {
                    showToast('Post reported.', 'success');
                    dispatch(closeModal());
                }
                else {
                    showToast('Error reporting post.', 'error');
                }
            }
            catch(err) {
                showToast('Error reporting post.', 'error');
            }
        }
        else {
            showToast('Please select reasons before reporting.', 'warning');
        }
    }

    return (
        <div className='w-[44%] rounded-xl px-6 py-[18px] flex flex-col gap-6 bg-[#FFFFFF]'>
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Report Post</h1>

                <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div className="flex flex-col gap-3">
                <p className='font-medium text-[16px] leading-9 text-[#121212]'>Select a reason that applies</p>

                <div className="flex items-center gap-2 flex-wrap">
                    {reportList.map(report => {
                        const isSelected = Boolean(reasons.find(item => item.id === report.id));

                        return (
                            <ReportType 
                                key={report.id} 
                                title={report.name} 
                                onClick={() => handleReportTypeClick(report)} 
                                selected={isSelected} 
                            />
                        )
                    })}
                </div>
            </div>

            <button onClick={handleSendReportButton} className={`${reasons.length > 0 ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'} text-buttonText outline-none w-full font-semibold text-base px-4 py-2 rounded`}>Send Report</button>
        </div>
    );
}

export default ReportPost;
